import { register, types } from "@gadgetinc/mobx-quick-tree";
import { GadgetDomainModelClass } from "./utils";
import { OpenAIApiKey } from "./environment-configs/OpenAIApiKey";
import { GoogleOAuthCredentials } from "./environment-configs/GoogleOauthCredentials";
import { SentryDatasource } from "./environment-configs/SentryDatasource";
import { ShopifyPartnerAppConfig } from "./connections/shopify/ShopifyPartnerAppConfig";
import { ShopifyAdminAppConfig } from "./connections/shopify/ShopifyAdminAppConfig";

export const EnvironmentConfiguration = types.union(
  types.late(() => OpenAIApiKey),
  types.late(() => GoogleOAuthCredentials),
  types.late(() => SentryDatasource),
  types.late(() => ShopifyAdminAppConfig),
  types.late(() => ShopifyPartnerAppConfig),
  types.late(() => types.reference(GoogleOAuthCredentials))
);

@register
export class EnvironmentConfig extends GadgetDomainModelClass("EnvironmentConfig", {
  configuration: EnvironmentConfiguration,
}) {
  get contentHash() {
    return this.configuration.contentHash;
  }
}
